<template>
  <div class="icon-box" id="consult">
    <!-- 展示的图标 -->
    <div class="display" @click="onShowNotifyModal">
      <auth-img
        id="consult icon-img"
        src="@/assets/img/chat/consult-notify.png"
        alt="问诊提醒"
        width="24"
      />
      <div class="icon-label">问诊提醒</div>
    </div>
    <!-- 弹出框显示问诊设置 -->
    <a-modal
      class="consult-modal"
      v-model:visible="notifyModal"
      title="问诊提醒设置"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="onCancel"
    >
      <p class="label">提醒患者：{{ patientInfo.username }}</p>
      <p v-if="doctorInfo.username">
        <label class="label">提醒医生：</label>
        {{ doctorInfo.username }}
      </p>
      <!-- 无医生数据 -->
      <p v-else>
        <label class="label">提醒医生：</label>
        <a-auto-complete
          v-model:value="doctor.name"
          placeholder="提醒医生名称"
          @select="onSelectDoctor($event)"
          @search="onSearchDoctor"
        >
          <template #options>
            <a-select-option v-for="d in doctor.options" :value="d.id" :key="d">
              {{ d.name }}
            </a-select-option>
          </template>
        </a-auto-complete>
      </p>
      <a-form layout="inline" name="consult-form" ref="consultDOM" :model="DT" :rules="rules">
        <a-form-item label="提醒时间：" name="date">
          <a-date-picker valueFormat="YYYY-MM-DD" v-model:value="DT.date" />
        </a-form-item>
        <a-form-item label="" name="time">
          <a-time-picker format="HH:mm" valueFormat="HH:mm:ss" v-model:value="DT.time" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script setup>
import useConsult from './hooks/useConsult'
const {
  patientInfo,
  doctorInfo,
  notifyModal,
  DT,
  consultDOM,
  rules,
  doctor,
  onSelectDoctor,
  onSearchDoctor,
  handleOk,
  onCancel,
  onShowNotifyModal
} = useConsult()
</script>
<style lang="scss" scoped>
@import '../../index.scss';
.consult {
  margin-right: 30px;

  .display {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #999;
    cursor: pointer;
  }
}

.consult-modal {
  .label {
    margin-left: 10px;
  }
}
</style>
